<script lang=ts setup>
  import playButton from "./play-button.vue";
  import { useFormLogger } from "../../../composables/use-form-logger.js";
  const { logger } = useFormLogger();
  const emit = defineEmits<{
    (e: 'playclicked', playclicked: boolean): void
  }>();

  const playVideo = () => {
    logger.debug('play video triggered');
    emit('playclicked', true);
  };
</script>

<template>
  <a class="noGateClick" href="javascript:void(0);" @click="playVideo">
    <div class="noGate16-9">

      <playButton />

      <p class="click-video">
        Please click to begin the video.
      </p>
      <p class="welcome">
        Welcome Back!<br>
        <span class="sub-text d-none d-md-block">
          Click the button below to begin the video
        </span>
      </p>
      <button class="btn btn-white">
        <i class="fas fa-play"></i>
        Play Video
      </button>
    </div>
  </a>
</template>